import { SVGProps } from 'react';

const GoogleMapsLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_368_15765)">
      <path
        d="M8.70898 17.7243C9.44903 18.6476 10.2027 19.8086 10.5972 20.5099C11.0775 21.4215 11.2767 22.0371 11.634 23.1396C11.8429 23.7435 12.0421 23.9266 12.46 23.9266C12.9169 23.9266 13.1258 23.6188 13.2859 23.1396C13.6198 22.1052 13.8776 21.3183 14.2857 20.5683C15.8595 17.6074 18.4252 15.5036 19.8701 12.6206C19.8701 12.6206 20.8211 10.8596 20.8211 8.3935C20.8211 6.09489 19.8838 4.49756 19.8838 4.49756L8.71484 17.7437L8.70898 17.7243Z"
        fill="#34A853"
      />
      <path
        d="M4.9209 12.3093C5.82105 14.3546 7.5374 16.1468 8.70897 17.7246L14.9183 10.3808C14.9183 10.3808 14.0416 11.5262 12.458 11.5262C10.6928 11.5262 9.2557 10.1236 9.2557 8.35098C9.2557 7.13155 9.98403 6.28613 9.98403 6.28613C5.41491 6.96403 5.66875 8.06852 4.90723 12.3054L4.9209 12.3093Z"
        fill="#FBBC04"
      />
      <path
        d="M14.9967 0.381836C17.0665 1.04609 18.8239 2.44668 19.8783 4.49205L14.9186 10.3944C14.9186 10.3944 15.647 9.54508 15.647 8.32955C15.647 6.51989 14.1161 5.15436 12.4642 5.15436C10.8963 5.15436 10.0039 6.28613 10.0039 6.28613C10.3847 5.42123 14.3192 0.675979 15.0026 0.383784L14.9967 0.381836Z"
        fill="#4285F4"
      />
      <path
        d="M6.05371 2.97844C7.28777 1.51357 9.45126 -0.00195312 12.4388 -0.00195312C13.8818 -0.00195312 14.9772 0.379849 14.9772 0.379849L9.998 6.28219C9.66215 6.10045 6.38566 3.55504 6.05371 2.97065V2.97844Z"
        fill="#1A73E8"
      />
      <path
        d="M4.92118 12.3093C4.92118 12.3093 4.10693 10.6964 4.10693 8.37444C4.10693 6.17324 4.96999 4.24475 6.05955 2.99805L10.0038 6.30959L4.92703 12.3093H4.92118Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_368_15765">
        <rect width="16.8889" height="24" fill="white" transform="translate(4)" />
      </clipPath>
    </defs>
  </svg>
);

export default GoogleMapsLogo;
